import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectorRef,
} from '@angular/core';
import { ActivatedRoute, Data, Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import moment from 'moment';
import { ProjectSheetsService } from 'app/modules/projects/details/sheets/sheets.service';
import { ProjectSheet } from 'app/modules/projects/details/sheets/sheets.types';
import { AddProjectSheetComponent } from 'app/modules/projects/details/sheets/add-project-sheet/add-project-sheet.component';
import { ConfirmService } from 'app/shared/components/widgets/dialog/confirm/confirm.service';

@Component({
  selector: 'project-sheets-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectSheetsListComponent implements OnInit, OnDestroy {
  projectSheets: ProjectSheet[];
  isLoading: boolean;
  pagination: any;
  projectSheetsCount: number = 0;

  projectSheetsTableColumns: string[];

  @ViewChild('noteList')
  noteList: ElementRef;

  // Private
  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {MailboxComponent} mailboxComponent
   */
  constructor(
    private _matDialog: MatDialog,
    private _projectSheetsService: ProjectSheetsService,
    private _changeDetectorRef: ChangeDetectorRef,
    private confirmService: ConfirmService,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    // Set the defaults
    this.isLoading = false;
    this.projectSheetsCount = 0;

    this.projectSheetsTableColumns = ['name', 'created_at', 'actions'];
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Notes
    this._projectSheetsService.projectSheets$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((projectSheets: ProjectSheet[]) => {
        if (projectSheets) {
          this.projectSheets = projectSheets;
          this.projectSheetsCount = projectSheets.length;
        }

        this._changeDetectorRef.markForCheck();
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions

    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  deleteProjectSheet(projectSheet): void {
    this.confirmService
      .openConfirmationModal()
      .pipe(filter((res: boolean) => res))
      .subscribe(() => {
        this._projectSheetsService.deleteProjectSheet(projectSheet.id).subscribe((projectSheet) => {
          this._changeDetectorRef.markForCheck();
        });
      });
  }

  openSheetTemplateDialog(): void {
    //show modal
    const dialogRef = this._matDialog.open(AddProjectSheetComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
